import { reactive } from 'vue';
import { createStore } from 'vuex';

export default createStore({
  state: {
    assetsPath: '/lp/assets/',
    showLoad: true,
    showNav: false,
    showMenu: false,
    showFloating: false,
    showModalCampaign: false,
    // showWorks: false,
    loadTime: 1.0,
  },
  mutations: {
    showLoad(state, isShow) {
      state.showLoad = isShow;
    },
    showNav(state, isShow) {
      state.showNav = isShow;
    },
    showMenu(state, isShow) {
      state.showMenu = isShow;
    },
    showFloating(state, isShow) {
      state.showFloating = isShow;
    },
    showModalCampaign(state, isShow) {
      state.showModalCampaign = isShow;
    },
    // showWorks(state, isShow) {
    //   state.showWorks = isShow;
    // },
  },
  actions: {},
  getters: {
    assetsPath(state) {
      return state.assetsPath;
    },
    showLoad: (state) => {
      return state.showLoad;
    },
    showNav: (state) => {
      return state.showNav;
    },
    showMenu: (state) => {
      return state.showMenu;
    },
    showFloating: (state) => {
      return state.showFloating;
    },
    showModalCampaign: (state) => {
      return state.showModalCampaign;
    },
    // showWorks: (state) => {
    //   return state.showWorks;
    // },
    loadTime: (state) => {
      return state.loadTime;
    },
  },
  modules: {},
});
